export default "__VITE_ASSET__1nZP_KnI__"